<template>
    <div>
        <FilterPanel
                v-if="filterDataSource"
                :dataSource="filterDataSource"
                v-bind:status.sync="status"
            />

        <v-row no-gutters>

            <v-col cols="12" xs="12" md="12">
                <v-data-table
                    :loading="loading"
                    :headers="headers"
                    :items="entities"
                    :item-class="itemRowBackground"
                    :options.sync="options"
                    :server-items-length="total"
                    :items-per-page="10"
                    :footer-props="{ itemsPerPageOptions: itemsPerPageSettings }"
                    :page.sync="options.page"
                    @page-count="paginationPageCount = $event"
                    class="elevation-1 customization-list-table pagination-list-table sticky-table"
                    @dblclick:row="(event, data) => $eventBus.$emit('open-document', { id: data.item.id, type: 'Chancellery|Documents|CitizenStatements.Document', common: data.item.iscommon })">
                    <v-progress-linear slot="progress" height="2" color="#E43958" indeterminate></v-progress-linear>

                    <template v-slot:[`item.regnumber`]="{ item }">
                        <td class="clt-col-wrap text-start">
                            <span class="clt-col-marker" :style="{ background: getColor(item) }"></span>{{ item.regnumber }}
                        </td>
                    </template>

                    <template v-slot:[`item.regdate`]="{ item }">
                        {{ formatDate(item.regdate) }}
                    </template>

                    <template v-slot:[`item.correspondent`]="{ item }">
                        <div class="etw-text-container">
                            <div class="etw-text" v-tooltip.top-center="item.correspondent">
                                {{item.correspondent}}
                            </div>
                        </div>
                    </template>

                    <template v-slot:[`item.theme`]="{ item }">
                        <div class="elipsis-text-wrap">
                            <v-doc-type-chip v-if="item.issubstitution" :type="'Substitution'" :text="$t('Замещение')"/>
                            <v-common-chip v-if="$helpers.getCommonStatusForList(item)" :document-type="item.doctypeof"/>
                            <v-doc-type-chip :type="item.doctypeof" :text="item.doctype"/>
                            <div class="etw-text-container">
                                <div class="etw-text" v-tooltip.top-center="item.theme">
                                    {{item.theme}}
                                </div>
                            </div>
                        </div>
                    </template>

                    <template v-slot:[`item.controldate`]="{ item }">
                        {{ formatDate(item.controldate) }}
                    </template>

                    <template v-slot:[`item.controldays`]="{ item }">
                        <StatusChip :status="avaibleStatuses[$helpers.getStatusByDays(item.controldays)]"/>
                    </template>

                    <template v-slot:[`footer.prepend`]>
                        <v-pagination
                            v-model="options.page"
                            :length="paginationPageCount"
                            :total-visible="$listPaginationTotal"
                            color="teal"
                        ></v-pagination>
                    </template>

                </v-data-table>
            </v-col>

        </v-row>
    </div>
</template>

<script>
import { httpAPI } from "@/api/httpAPI";
import { mapActions, mapGetters } from 'vuex';
import sys from '@/services/system';
import StatusChip from '@/components/global/chips/StatusChip';
import FilterPanel from '@/components/documents/FilterPanel.vue';

export default {
    columnIndex:  {
        'regnumber': 4,
        'regdate': 5,
        'correspondent': 6,
        'theme': 7,
        'controldate': 8
    },
    props: {
        search: {
            type: String,
            default: ""
        }
    },
    components: {
        StatusChip,
        FilterPanel
    },
    computed: {
        ...mapGetters({ itemsPerPageSettings: 'getItemsPerPageSettings' }),
        headers() {
            return [
                { text: this.$t("Номер"), value: 'regnumber', width: '150px'  },
                { text: this.$t("Рег._дата"), value: 'regdate', width: '110px'  },
                { text: this.$t("Корреспондент"), value: 'correspondent', width: '20%' },
                { text: this.$t("Краткое_содержание"), value: 'theme' },
                { text: this.$t("Срок"), value: 'controldate', width: '110px'  },
                { text: this.$t("Статус"), value: 'controldays', sortable: false, width: '150px'  }
            ];
        },
        options: {
            get: function() {
                return this.$store.getters['correspondence/inWork/onExecution/getTableOptions'];
            },
            set: function(newValue) {
                this.$store.commit('correspondence/inWork/onExecution/SET_TABLE_OPTION', newValue);
            }
        },
        status: {
            get: function() {
                return this.$store.getters['correspondence/inWork/onExecution/getStatus'];
            },
            set: function(newValue) {
                if (typeof this.$refs.currentComponent?.resetPage === "function")
                    this.$refs.currentComponent.resetPage();

                this.$store.commit('correspondence/inWork/onExecution/SET_STATUS', newValue);
            }
        },
        filter () {
            return {
                ...this.options,
                SearchStr: this.search,
                ExecutionStatus: this.status
            }
        },
        avaibleStatuses() {
            return this.$store.getters['documents/references/GetAvaibleStatuses'];
        }
    },
    data () {
        return {
            filterDataSource: {
                Filter: {
                    Title: "Исполнение",
                    Default: "Any",
                    Items: [
                        { Name: "Любой", Value: "Any", Count: -1 },
                        { Name: "Более_10_дней", Value: "MoreThan10Days", Count: -1 },
                        { Name: "Менее_10_дней", Value: "LessThan10Days", Count: -1 },
                        { Name: "Сегодня", Value: "Today", Count: -1 },
                        { Name: "Просрочено", Value: "Expired", Count: -1 }
                    ]
                }
            },
            loading: true,
            total: 0,            
            entities: [],

            prevTableFilterObject: null,
            paginationPageCount: 0,
        }
    },
    methods: {
        ...mapActions(['setOverlayVisible']),
        itemRowBackground(item) {
            return item.readed ? '' : 'font-weight-bold';
        },
        resetPage() {
            this.$store.commit('correspondence/inWork/onExecution/SET_TABLE_OPTION_PAGE', 1);
        },
        async getData(isRefresh = false) {
            const newTableFilter = this.getTableFilterObject();
            if (isRefresh === false && this.$_.isEqual(this.prevTableFilterObject, newTableFilter))
                return;

            this.setOverlayVisible({ visible: true });
            this.prevTableFilterObject = newTableFilter;

            this.total = 0;
            this.entities = [];
            this.loading = true;

            let response = await httpAPI({
                url: `/api/correspondence/inwork/list?type=MyDocuments.OnExecution&filter=${newTableFilter}`,
                method: 'GET'
            });
            
            this.entities = response?.data?.Payload?.data ?? [];
            this.total = response?.data?.Payload?.total ?? 0;
            if (response?.data?.Payload?.counts){
                const counts = response.data.Payload.counts;
                this.filterDataSource.Filter.Items.forEach(item => {
                    switch (item.Value){
                        case "Any":
                            item.Count = counts.total;
                            break;
                        case "MoreThan10Days":
                            item.Count = counts.morethan10days;
                            break;
                        case "LessThan10Days":
                            item.Count = counts.lessthan10days;
                            break;
                        case "Today":
                            item.Count = counts.today;
                            break;
                        case "Expired":
                            item.Count = counts.expired;
                            break;
                    }
                });
            }

            this.loading = false;
            this.setOverlayVisible({ visible: false });
            this.$eventBus.$emit('update_correspondents_counters');
        },
        getTableFilterObject() {
            let { sortBy, sortDesc, page, itemsPerPage, SearchStr, ExecutionStatus } = this.filter;
            let OrderDir = sortDesc.length <= 0 ? false : sortDesc[0];
            let sortColumn = sortBy.length <= 0 ? "regdate" : sortBy[0];
            let OrderBy = this.$options.columnIndex[sortColumn] ?? 5;
            return JSON.stringify({ ExecutionStatus, SearchStr, OrderBy, OrderDir, Limit: itemsPerPage, Offset: (page - 1) * itemsPerPage });
        },
        formatDate(value) {
            if (!value)
                return '';

            return this.$moment(value).format('DD.MM.YYYY');
        },
        getColor(item) {
            return sys.getExecutionColorStatus(item.controldate);
        },
    },
    watch: {
        filter: {
            handler() {
                this.getData()
            },
            deep: true,
        },
    },
    async created() {
        this.options.itemsPerPage = this.itemsPerPageSettings[0];
    }
}
</script>